import { Action, Dispatch } from "redux";
import initialState from "../initialState";
import { NotificationActions } from "./notification/notification-actions";
import { AppDispatch } from "./index";
import { getApi } from "../api/ApiProvider";

export enum AdminActionTypes {
  FETCH_REQUEST = "[ADMIN][LIST] Request",
  FETCH_RESPONSE = "[ADMIN][LIST] Response",
  FETCH_ERROR = "[ADMIN][ERROR] Error",

  ADD_REQUEST = "[ADMIN][ADD] Request",
  ADD_RESPONSE = "[ADMIN][ADD] Response",
  ADD_ERROR = "[ADMIN][ADD] Error",

  ADD_REQUEST_EXTENDED = "[ADMIN][ADD][EXTENDED] Request",
  ADD_RESPONSE_EXTENDED = "[ADMIN][ADD][EXTENDED] Response",
  ADD_ERROR_EXTENDED = "[ADMIN][ADD][EXTENDED] Error",

  UPDATE_REQUEST = "[ADMIN][UPDATE] Request",
  UPDATE_RESPONSE = "[ADMIN][UPDATE] Response",
  UPDATE_ERROR = "[ADMIN][UPDATE] Error",

  ACTIVATE_REQUEST = "[ADMIN][ACTIVATE] Request",
  ACTIVATE_RESPONSE = "[ADMIN][ACTIVATE] Response",
  ACTIVATE_ERROR = "[ADMIN][ACTIVATE] Error",

  DISABLE_REQUEST = "[ADMIN][DISABLE] Request",
  DISABLE_RESPONSE = "[ADMIN][DISABLE] Response",
  DISABLE_ERROR = "[ADMIN][DISABLE] Error",
}

export interface IAdminStore {
  data: {
    fetching: boolean;
    error?: any;
    data?: any;
  };
  add: {
    fetching: boolean;
    error?: any;
    data?: any;
  };

  disable: {
    fetching: boolean;
    error?: any;
    data?: any;
  };
  activate: {
    fetching: boolean;
    error?: any;
    data?: any;
  };
}

export default (
  state: IAdminStore = initialState.admin,
  action?: Action<AdminActionTypes> & { payload: any }
) => {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case AdminActionTypes.FETCH_REQUEST:
      return {
        ...state,
        data: {
          fetching: true,
          error: null,
          data: null,
        },
      };

    case AdminActionTypes.FETCH_RESPONSE:
      return {
        ...state,
        data: {
          fetching: false,
          data: action.payload,
          error: null,
        },
      };

    case AdminActionTypes.FETCH_ERROR:
      return {
        ...state,
        data: {
          fetching: false,
          data: null,
          error: action.payload,
        },
      };

    case AdminActionTypes.ADD_REQUEST:
      return {
        ...state,
        add: { fetching: true },
      };
    case AdminActionTypes.ADD_RESPONSE:
      if (state.data && state.data.data) {
        return {
          ...state,
          data: {
            data: state.data.data.concat(action.payload),
            fetching: false,
          },
          add: { fetching: false, data: action.payload },
        };
      }
      return {
        ...state,
        add: { fetching: false, data: action.payload },
      };
    case AdminActionTypes.ADD_ERROR:
      return {
        ...state,
        add: { fetching: false, error: action.payload },
      };

    case AdminActionTypes.ADD_REQUEST_EXTENDED:
      return {
        ...state,
        add: { fetching: true },
      };
    case AdminActionTypes.ADD_RESPONSE_EXTENDED:
      if (state.data && state.data.data) {
        return {
          ...state,
          data: {
            data: state.data.data.concat(action.payload),
            fetching: false,
          },
          add: { fetching: false, data: action.payload },
        };
      }
      return {
        ...state,
        add: { fetching: false, data: action.payload },
      };
    case AdminActionTypes.ADD_ERROR_EXTENDED:
      return {
        ...state,
        add: { fetching: false, error: action.payload },
      };

    case AdminActionTypes.DISABLE_REQUEST:
      return { ...state, disable: { fetching: true } };

    case AdminActionTypes.DISABLE_RESPONSE:
      if (state.data && state.data.data) {
        const index = state.data.data.findIndex(
          (el: any) => el.id === action.payload.id
        );
        const admins = state.data.data;
        const adminsData = [...admins];
        adminsData.splice(index, 1);
        return {
          ...state,
          data: {
            ...state.data,
            data: adminsData.concat(action.payload),
          },
        };
      }
      return {
        ...state,
        disable: { fetching: false, data: action.payload },
      };
    case AdminActionTypes.DISABLE_ERROR:
      return { ...state, error: action.payload };

    case AdminActionTypes.ACTIVATE_REQUEST:
      return { ...state, activate: { fetching: true } };

    case AdminActionTypes.ACTIVATE_RESPONSE:
      if (state.data && state.data.data) {
        const index2 = state.data.data.findIndex(
          (el: any) => el.id === action.payload.id
        );
        const admins2 = state.data.data;
        const adminsData2 = [...admins2];
        adminsData2.splice(index2, 1);

        return {
          ...state,
          data: {
            ...state.data,
            data: adminsData2.concat(action.payload),
          },
        };
      }
      return {
        ...state,
        activate: { fetching: false, data: action.payload },
      };
    case AdminActionTypes.ACTIVATE_ERROR:
      return { ...state, error: action.payload };

    default:
      return state;
  }
};

export class AdminActions {
  add(data: { name: string; pass: string; email: string }) {
    return (dispatch: AppDispatch) => {
      const notif = new NotificationActions();

      dispatch({ type: AdminActionTypes.ADD_REQUEST });

      getApi()
        .admin()
        .add(data)
        .then((response) => {
          dispatch(notif.addSuccess("Usuario", "Usuario agregado"));
          dispatch({ type: AdminActionTypes.ADD_RESPONSE, payload: response });
        })
        .catch((err) => {
          dispatch(
            notif.addError(
              "Usuario",
              "Inconvenientes al agregar. Verifique sus datos"
            )
          );
          dispatch({ type: AdminActionTypes.ADD_ERROR, payload: err });
        });
    };
  }
  addExtended(data: {
    name: string;
    pass: string;
    email: string;
    branch: number;
  }) {
    return (dispatch: AppDispatch) => {
      const notif = new NotificationActions();

      dispatch({ type: AdminActionTypes.ADD_REQUEST });

      getApi()
        .admin()
        .addExtended(data)
        .then((response) => {
          dispatch(notif.addSuccess("Usuario", "Usuario agregado a sucursal"));
          dispatch({ type: AdminActionTypes.ADD_RESPONSE, payload: response });
          dispatch(this.fetch());
        })
        .catch((err) => {
          dispatch(
            notif.addError(
              "Usuario",
              "Inconvenientes al agregar a sucursal. Verifique sus datos"
            )
          );
          dispatch({ type: AdminActionTypes.ADD_ERROR, payload: err });
        });
    };
  }

  updateBranch(adminId: number, branch: number) {
    return (dispatch: AppDispatch) => {
      dispatch({ type: AdminActionTypes.DISABLE_REQUEST });
      getApi()
        .admin()
        .updateBranch(adminId, branch)
        .then((response: any) => {
          console.log("Update admin branch: -->", response);

          dispatch(this.fetch());
        })
        .catch((err: any) => {
          dispatch({ type: AdminActionTypes.UPDATE_ERROR, payload: err });
        });
    };
  }
  disable(data: any) {
    return (dispatch: AppDispatch) => {
      const notif = new NotificationActions();

      dispatch({ type: AdminActionTypes.DISABLE_REQUEST });
      getApi()
        .admin()
        .disable(data.id)
        .then((admin: any) => {
          console.log("response de admin: --> ", admin);

          dispatch({ type: AdminActionTypes.DISABLE_RESPONSE, payload: admin });
          dispatch(
            notif.addSuccess("Administrador", "Administrador desactivado")
          );
        })
        .catch((err) => {
          dispatch({ type: AdminActionTypes.DISABLE_ERROR, payload: err });
        });
    };
  }

  activate(data: any) {
    return (dispatch: AppDispatch) => {
      const notif = new NotificationActions();

      dispatch({ type: AdminActionTypes.ACTIVATE_REQUEST });
      getApi()
        .admin()
        .activate(data.id)
        .then((admin: any) => {
          dispatch({
            type: AdminActionTypes.ACTIVATE_RESPONSE,
            payload: admin,
          });
          dispatch(notif.addSuccess("Administrador", "Administrador activado"));
        })
        .catch((err) => {
          dispatch({ type: AdminActionTypes.ACTIVATE_ERROR, payload: err });
        });
    };
  }

  fetch() {
    return (dispatch: Dispatch) => {
      dispatch({ type: AdminActionTypes.FETCH_REQUEST });
      getApi()
        .admin()
        .list()
        .then((data) => {
          dispatch({ type: AdminActionTypes.FETCH_RESPONSE, payload: data });
        })
        .catch((err) => {
          dispatch({ type: AdminActionTypes.FETCH_ERROR, payload: err });
        });
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/admin.ts